/**
 * Fixed, full-viewport ambient layer behind all content. Theme-aware:
 *  - light  → warm paper canvas + faint editorial grid
 *  - dark   → deep cosmic wash + slow-drifting aurora blobs + grid
 * Pure CSS, GPU-cheap. Colours/grid follow the --surface / --grid-line vars.
 */
export default function AuroraBackground() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      {/* theme surface */}
      <div className="absolute inset-0" style={{ background: "var(--surface)" }} />

      {/* drifting aurora blobs — only in dark mode */}
      <div className="absolute -top-32 -left-24 h-[36rem] w-[36rem] rounded-full bg-aurora-violet/25 opacity-0 blur-[120px] animate-drift transition-opacity duration-700 dark:opacity-100" />
      <div className="absolute top-1/3 -right-24 h-[34rem] w-[34rem] rounded-full bg-aurora-cyan/20 opacity-0 blur-[120px] animate-float-slow transition-opacity duration-700 dark:opacity-100" />
      <div
        className="absolute bottom-[-10rem] left-1/4 h-[38rem] w-[38rem] rounded-full bg-aurora-pink/20 opacity-0 blur-[130px] animate-drift transition-opacity duration-700 dark:opacity-100"
        style={{ animationDelay: "-6s" }}
      />
      <div
        className="absolute top-1/4 left-1/2 h-[28rem] w-[28rem] -translate-x-1/2 rounded-full bg-aurora-indigo/20 opacity-0 blur-[110px] animate-float-slow transition-opacity duration-700 dark:opacity-100"
        style={{ animationDelay: "-3s" }}
      />

      {/* editorial grid (adapts via --grid-line), faded toward the edges */}
      <div className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,black,transparent_82%)]" />

      {/* gentle vignette to settle the corners */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/[0.04] dark:to-black/40" />
    </div>
  );
}
